var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeometry({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8319 3.68146C11.5392 2.56099 11.8928 2.00075 12.3562 1.83198C12.6752 1.71584 13.0247 1.71584 13.3437 1.83198C13.8071 2.00075 14.1607 2.56099 14.868 3.68146C15.6641 4.94264 16.0622 5.57323 15.992 6.09355C15.944 6.45043 15.7643 6.77647 15.4885 7.00772C15.0862 7.34487 14.3408 7.34487 12.85 7.34487C11.3591 7.34487 10.6137 7.34487 10.2114 7.00772C9.93557 6.77647 9.75595 6.45043 9.70786 6.09355C9.63772 5.57323 10.0358 4.94264 10.8319 3.68146Z",
    stroke: "#141B34",
    strokeWidth: 1.05,
    strokeLinejoin: "round",
    className: "only-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.54487C2 3.37829 2 2.795 2.29709 2.38609C2.39303 2.25404 2.50917 2.1379 2.64122 2.04196C3.05013 1.74487 3.63341 1.74487 4.8 1.74487C5.96658 1.74487 6.54987 1.74487 6.95878 2.04196C7.09083 2.1379 7.20697 2.25404 7.30291 2.38609C7.6 2.795 7.6 3.37829 7.6 4.54487C7.6 5.71146 7.6 6.29475 7.30291 6.70365C7.20697 6.83571 7.09083 6.95184 6.95878 7.04779C6.54987 7.34487 5.96658 7.34487 4.8 7.34487C3.63341 7.34487 3.05013 7.34487 2.64122 7.04779C2.50917 6.95184 2.39303 6.83571 2.29709 6.70365C2 6.29475 2 5.71146 2 4.54487Z",
    stroke: "#141B34",
    strokeWidth: 1.05,
    strokeLinejoin: "round",
    className: "only-stroke"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.85 15.7449C14.3964 15.7449 15.65 14.4913 15.65 12.9449C15.65 11.3985 14.3964 10.1449 12.85 10.1449C11.3037 10.1449 10.05 11.3985 10.05 12.9449C10.05 14.4913 11.3037 15.7449 12.85 15.7449Z",
    stroke: "#141B34",
    strokeWidth: 1.05,
    strokeLinejoin: "round",
    className: "only-stroke"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24993 10.4949L2.34998 15.3949M2.35002 10.4949L7.24998 15.3949",
    stroke: "#141B34",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "only-stroke"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeometry);
export default __webpack_public_path__ + "static/media/geometry.868f1e8dc2cf94c9585b28c633e92f2e.svg";
export { ForwardRef as ReactComponent };